module.exports = __webpack_public_path__ + "img/m-logo.16f713b7.png";